import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {
  FaPaperPlane as FaPaperPlaneRaw,
  FaEye as FaEyeRaw,
  FaSync as FaSyncRaw,
  FaDollarSign as FaDollarSignRaw,
} from 'react-icons/fa';
import { useMarketingCampaigns } from '../hooks/useMarketing';
import MarketingHeader from '../components/MarketingHeader';
import { Table, TableWrap } from '../styles/marketingSharedStyles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FaPaperPlane: any = FaPaperPlaneRaw;
const FaEye: any = FaEyeRaw;
const FaSync: any = FaSyncRaw;
const FaDollarSign: any = FaDollarSignRaw;

const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  min-height: 0;
`;

const PageContent = styled.div`
  padding: 0 1.5rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const ReportsSubNav = styled.nav`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  border-bottom: 1px solid var(--outline);
`;
const SubNavLink = styled.button<{ $active?: boolean }>`
  padding: 0.6rem 1rem;
  font-size: 0.9rem;
  color: ${({ $active }) => ($active ? 'var(--primary)' : 'var(--onSurfaceVariant)')};
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  background: none;
  border: none;
  border-bottom: 2px solid ${({ $active }) => ($active ? 'var(--primary)' : 'transparent')};
  margin-bottom: -1px;
  cursor: pointer;
  &:hover {
    color: var(--primary);
  }
`;

const SearchInput = styled.input`
  border: 1px solid var(--outline);
  border-radius: 8px;
  padding: 0.5rem 0.75rem 0.5rem 2rem;
  font-size: 0.9rem;
  color: var(--onSurfaceVariant);
  background: var(--surface) url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%239ca3af' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'/%3E%3C/svg%3E") no-repeat 0.6rem center;
  background-size: 1rem;
  min-width: 200px;
  &::placeholder {
    color: var(--onSurfaceVariant);
  }
`;

const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const KpiCard = styled.div`
  background: var(--surfaceVariant);
  border-radius: 12px;
  padding: 1rem 1.25rem;
  border: 1px solid var(--outline);
`;
const KpiLabel = styled.div`
  font-size: 0.8rem;
  color: var(--onSurfaceVariant);
  margin-bottom: 0.25rem;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  & svg {
    color: var(--primary);
  }
`;
const KpiValue = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--onSurface);
`;
const KpiChange = styled.span<{ $positive?: boolean }>`
  font-size: 0.8rem;
  color: ${({ $positive }) => ($positive === true ? 'var(--success)' : $positive === false ? 'var(--error)' : 'var(--onSurfaceVariant)')};
  margin-top: 0.25rem;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
`;

const Card = styled.section`
  background: var(--surface);
  border: 1px solid var(--outline);
  border-radius: 12px;
  padding: 1.25rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`;

const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 0.75rem;
`;
const CardTitle = styled.h2`
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--onSurface);
`;
const CardSub = styled.p`
  margin: 0.25rem 0 0 0;
  font-size: 0.8rem;
  color: var(--onSurfaceVariant);
`;

const TimeToggle = styled.div`
  display: flex;
  gap: 0;
  border: 1px solid var(--outline);
  border-radius: 8px;
  overflow: hidden;
`;
const TimeBtn = styled.button<{ $active?: boolean }>`
  padding: 0.4rem 0.75rem;
  font-size: 0.85rem;
  border: none;
  background: ${({ $active }) => ($active ? 'var(--primary)' : 'var(--surface)')};
  color: ${({ $active }) => ($active ? 'var(--onPrimary)' : 'var(--onSurfaceVariant)')};
  font-weight: 500;
  cursor: pointer;
  &:hover {
    background: ${({ $active }) => ($active ? 'var(--primary)' : 'var(--surfaceVariant)')};
    color: ${({ $active }) => ($active ? 'var(--onPrimary)' : 'var(--primary)')};
  }
`;

const LineChartWrap = styled.div`
  height: 220px;
  position: relative;
  margin-top: 0.5rem;
`;
const LineChartSvg = styled.svg`
  width: 100%;
  height: 100%;
  overflow: visible;
`;


const StatusBadge = styled.span<{ $variant: 'completed' | 'active' | 'archived' }>`
  display: inline-block;
  padding: 0.25rem 0.6rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  background: ${({ $variant }) =>
    $variant === 'completed' ? 'var(--successContainer)' : $variant === 'active' ? 'var(--surfaceVariant)' : 'var(--elevation2)'};
  color: ${({ $variant }) =>
    $variant === 'completed' ? 'var(--success)' : $variant === 'active' ? 'var(--primary)' : 'var(--onSurfaceVariant)'};
`;

const ViewAllLink = styled(Link)`
  color: var(--primary);
  font-size: 0.85rem;
  font-weight: 500;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const Loading = styled.p`
  margin: 0;
  color: var(--onSurfaceVariant);
  font-size: 0.9rem;
`;
const Empty = styled.p`
  margin: 0;
  color: var(--onSurfaceVariant);
  font-size: 0.9rem;
`;

function formatReportDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

// Mock series for line chart (last 30 days shape)
const CHART_POINTS = [32, 45, 38, 52, 48, 61, 58, 72, 68, 78, 75, 82, 80, 88, 85, 90, 87, 92, 90, 95, 92, 88, 90, 85, 82, 78, 80, 76, 74, 72];

export default function ReportsPage() {
  const [reportTab, setReportTab] = useState<'overview' | 'campaign' | 'links' | 'revenue'>('overview');
  const [chartRange, setChartRange] = useState<'30' | '90'>('30');
  const campaigns = useMarketingCampaigns();

  const recentCampaigns = useMemo(() => {
    const list = campaigns.data ?? [];
    return list.slice(0, 8);
  }, [campaigns.data]);

  const chartData = useMemo(() => {
    const arr = chartRange === '90'
      ? Array.from({ length: 90 }, (_, i) => (i < 30 ? CHART_POINTS[i] : 70 + Math.sin(i / 10) * 12))
      : CHART_POINTS;
    const w = 800;
    const h = 180;
    const max = Math.max(...arr);
    const min = Math.min(...arr);
    const range = max - min || 1;
    const step = w / (arr.length - 1);
    const coords = arr.map((y, i) => {
      const x = i * step;
      const ny = h - ((y - min) / range) * (h - 20) - 10;
      return `${x},${ny}`;
    });
    const linePath = `M ${coords.join(' L ')}`;
    const lastX = (arr.length - 1) * step;
    const areaPath = `${linePath} L ${lastX},${h} L 0,${h} Z`;
    return { linePath, areaPath };
  }, [chartRange]);

  return (
    <Page>
      <MarketingHeader
        activeTab="reports"
        rightSlot={
          <SearchInput type="search" placeholder="Search reports..." aria-label="Search reports" />
        }
      />
      <PageContent>
      <ReportsSubNav>
        <SubNavLink $active={reportTab === 'overview'} onClick={() => setReportTab('overview')}>
          Overview
        </SubNavLink>
        <SubNavLink $active={reportTab === 'campaign'} onClick={() => setReportTab('campaign')}>
          Campaign Performance
        </SubNavLink>
        <SubNavLink $active={reportTab === 'links'} onClick={() => setReportTab('links')}>
          Link Tracking
        </SubNavLink>
        <SubNavLink $active={reportTab === 'revenue'} onClick={() => setReportTab('revenue')}>
          Revenue Distribution
        </SubNavLink>
      </ReportsSubNav>

      {reportTab === 'overview' && (
        <>
          <KpiGrid>
            <KpiCard>
              <KpiLabel><FaPaperPlane size={12} /> Total Messages Sent</KpiLabel>
              <KpiValue>1,284,500</KpiValue>
              <KpiChange $positive={true}>+12.3%</KpiChange>
            </KpiCard>
            <KpiCard>
              <KpiLabel><FaEye size={12} /> Avg. Open Rate</KpiLabel>
              <KpiValue>18.5%</KpiValue>
              <KpiChange $positive={true}>+2.1%</KpiChange>
            </KpiCard>
            <KpiCard>
              <KpiLabel><FaSync size={12} /> Total Click-Throughs</KpiLabel>
              <KpiValue>42,301</KpiValue>
              <KpiChange $positive={false}>−0.5%</KpiChange>
            </KpiCard>
            <KpiCard>
              <KpiLabel><FaDollarSign size={12} /> Revenue Generated</KpiLabel>
              <KpiValue>$12,450</KpiValue>
              <KpiChange $positive={true}>+8.4%</KpiChange>
            </KpiCard>
          </KpiGrid>

          <Card>
            <CardHeader>
              <div>
                <CardTitle>Campaign Performance Over Time</CardTitle>
                <CardSub>Tracking message volume and engagement for the last {chartRange === '30' ? '30' : '90'} days</CardSub>
              </div>
              <TimeToggle>
                <TimeBtn $active={chartRange === '30'} onClick={() => setChartRange('30')}>
                  Last 30 Days
                </TimeBtn>
                <TimeBtn $active={chartRange === '90'} onClick={() => setChartRange('90')}>
                  Last 90 Days
                </TimeBtn>
              </TimeToggle>
            </CardHeader>
            <LineChartWrap>
              <LineChartSvg viewBox="0 0 800 200" preserveAspectRatio="none">
                <defs>
                  <linearGradient id="chartGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="var(--primary)" stopOpacity={0.35} />
                    <stop offset="100%" stopColor="var(--primary)" stopOpacity={0} />
                  </linearGradient>
                </defs>
                <path fill="url(#chartGradient)" d={chartData.areaPath} />
                <path fill="none" stroke="var(--primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d={chartData.linePath} />
              </LineChartSvg>
            </LineChartWrap>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Recent Messages</CardTitle>
              <ViewAllLink to="/marketing/messages">View all messages</ViewAllLink>
            </CardHeader>
            {campaigns.isLoading && <Loading>Loading messages…</Loading>}
            {!campaigns.isLoading && recentCampaigns.length === 0 && (
              <Empty>No messages yet. Create one from the Dashboard.</Empty>
            )}
            {!campaigns.isLoading && recentCampaigns.length > 0 && (
              <TableWrap>
                <Table>
                  <thead>
                    <tr>
                      <th>Message name</th>
                      <th>Sent</th>
                      <th>Delivered</th>
                      <th>CTR</th>
                      <th>Opt-outs</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recentCampaigns.map((c, idx) => {
                      const meta = (c.metadata || {}) as { sent?: number; delivered_pct?: number; ctr?: number; opt_outs_pct?: number };
                      const sent = meta.sent ?? [45000, 12402, 150000, 22100, 8500, 32000, 18000, 9500][idx % 8];
                      const deliveredPct = meta.delivered_pct ?? (c.status === 'archived' ? 96.8 : c.status === 'scheduled' ? 99.1 : 98.2);
                      const ctr = meta.ctr ?? (c.status === 'scheduled' ? 24.8 : [12.4, 8.9, 4.2][idx % 3]);
                      const optOuts = meta.opt_outs_pct ?? [0.05, 0.02, 0.12, 1.45][idx % 4];
                      const statusVariant = c.status === 'archived' ? 'archived' : c.status === 'scheduled' ? 'active' : 'completed';
                      const statusLabel = c.status === 'archived' ? 'Archived' : c.status === 'scheduled' ? 'Active' : 'Completed';
                      return (
                        <tr key={c.id}>
                          <td>
                            <strong>{c.name}</strong>
                            <br />
                            <span style={{ fontSize: '0.8rem', color: 'var(--onSurfaceVariant)' }}>
                              {c.status === 'scheduled' ? 'Ongoing' : `Sent ${formatReportDate(c.updated_at)}`}
                            </span>
                          </td>
                          <td>{sent.toLocaleString()}</td>
                          <td>{deliveredPct.toFixed(1)}%</td>
                          <td>{ctr.toFixed(1)}%</td>
                          <td>{optOuts.toFixed(2)}%</td>
                          <td>
                            <StatusBadge $variant={statusVariant}>{statusLabel}</StatusBadge>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </TableWrap>
            )}
          </Card>
        </>
      )}

      {reportTab === 'campaign' && (
        <Card>
          <CardTitle>Campaign Performance</CardTitle>
          <CardSub>Detailed breakdown by campaign. (Placeholder — add filters and export.)</CardSub>
        </Card>
      )}
      {reportTab === 'links' && (
        <Card>
          <CardTitle>Link Tracking</CardTitle>
          <CardSub>Track clicks and conversions by link. (Placeholder.)</CardSub>
        </Card>
      )}
      {reportTab === 'revenue' && (
        <Card>
          <CardTitle>Revenue Distribution</CardTitle>
          <CardSub>Revenue by campaign and channel. (Placeholder.)</CardSub>
        </Card>
      )}
      </PageContent>
    </Page>
  );
}
